import React from "react";
import { useField } from "formik";

import { TOption } from "../../../models/option.model";

import { wrap, heading, buttons, button, buttonSelected } from "./price-buttons-filters.module.scss";

export interface IPriceButtonsFiltersProps {
    name: string;
    options: TOption[];
    label: string;
    className?: string;
}

function getOptionStoredValue(option: TOption): string | number {
    return option.value ?? option.id;
}

function isSameValue(a: string | number | undefined, b: string | number): boolean {
    if (a === undefined || a === null) return false;
    return a === b || String(a) === String(b);
}

const PriceButtonsFilters: React.FC<IPriceButtonsFiltersProps> = ({
    name,
    options,
    label,
    className = "",
}) => {
    const [, meta, helpers] = useField<string | number>(name);

    return (
        <div className={`${wrap} ${className}`}>
            <p className={heading}>{label}</p>
            <div className={buttons} role="group" aria-label={label}>
                {options.map((option) => {
                    const stored = getOptionStoredValue(option);
                    const selected = isSameValue(meta.value, stored);
                    return (
                        <button
                            key={String(stored)}
                            type="button"
                            className={`${button} ${selected ? buttonSelected : ""}`}
                            onClick={() => helpers.setValue(stored)}
                            aria-pressed={selected}
                        >
                            {option.label}
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export default PriceButtonsFilters;
